var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1623_17697)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43627 18.184C2.44614 18.1833 0 15.7696 0 12.8196C0 9.86926 2.44691 7.45532 5.43763 7.45532L10.1181 7.45538C10.1181 10.9878 10.2395 14.6968 10.1181 18.184H5.43627ZM10.187 20.2148C10.2809 21.1045 10.4624 21.9858 10.7461 22.8269C11.1754 24.1 11.8676 25.3479 12.8858 26.2554C13.0817 26.4302 13.1587 26.6751 13.1074 26.9295L12.6545 29.1753C12.6058 29.4173 12.4515 29.6021 12.2194 29.6944C11.9804 29.7893 11.7452 29.7621 11.5341 29.6172C9.85791 28.4663 8.63374 26.7751 7.83347 24.9389C7.18251 23.4454 6.79787 21.8385 6.64547 20.2148H10.187ZM12.1766 7.21766V18.3797C17.962 19.622 22.7732 23.0306 27.3703 25.8571C27.9269 26.1994 28.6262 25.9838 29.1658 25.6318C29.7054 25.2797 30 24.7541 30 24.1428V1.60568C30 0.996483 29.7075 0.472363 29.1709 0.12004C28.6342 -0.232225 27.9767 -0.380408 27.3824 -0.112518C23.2071 1.77074 17.89 5.73653 12.1766 7.21766Z",
    fill: "#009b9b"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1623_17697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.5ec76e75325250f0b5e3566e6f6c85b5.svg";
export { ForwardRef as ReactComponent };